import React from "react";
import { IconButton } from "@material-ui/core";
import { Call as CallIcon } from "@material-ui/icons";

const TablePhoneNo = (props) => {
	return (
		<div display="flex">
			<IconButton onClick={props.dialHandler}>
				<CallIcon style={{ color: "#63b500" }} />
			</IconButton>
			{props.phone}
		</div>
	);
};

export default TablePhoneNo;
